import {createSlice} from "@reduxjs/toolkit";
import {clearAuthToken, getAuthToken} from "../../helpers/helperFunctions";

const initialState = {
  token: getAuthToken(),
  user: getAuthToken()?.user,
  loading: false,
  appLoading: {
    loading: false
  }
};

const authTokenSlice = createSlice({
  name: 'authToken',
  initialState: initialState,
  reducers: {
    setAuthToken: (state, action) => {
      const authToken = getAuthToken();
      state.user = authToken?.user;
      state.token = authToken;
    },
    setUserProfile: (state, action) => {
      state.user = action.payload.user;
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setAppLoading: (state, action) => {
      state.appLoading.loading = action.payload ?? true;
    },
    clearToken: (state, action) => {
      clearAuthToken()
      return {
        ...state, ...{
          token: {},
          loading: false,
          user: undefined
        }
      };
    },
    tryGetUsersProfile: (state, action) => {

    }
  }
});


export const {
  setAuthToken,
  setLoading,
  clearToken,
  setAppLoading,
  tryGetUsersProfile,
  setUserProfile
} = authTokenSlice.actions;

export default authTokenSlice.reducer;
